// Règles de navigation partagées par les composants Link de cette lib
// (TypographyLink, FlexBoxLink, LinkWrapper). Elles déterminent si un lien doit
// être routé en client-side (SPA : <Link> Gatsby / navigate) ou servi par une
// navigation navigateur complète (<a> natif / window.location).
//
// Régression RUN-8018 (audit Clean Rising Sun) : le garde qui excluait les
// fichiers statiques du routing SPA avait été retiré, envoyant un lien interne
// vers un PDF (allergènes) dans le routing @reach/router → 404 PWA. Ces
// prédicats centralisent la décision pour éviter que le cas ne réapparaisse sur
// l'un des composants frères.

/** Chemin interne : commence par un seul "/" (exclut "//host" protocol-relative). */
export const isInternal = (path: string): boolean => /^\/(?!\/)/.test(path);

/**
 * Fichier statique : le chemin se termine par une extension (.pdf, .jpg…),
 * éventuellement suivie d'une query string ou d'un hash. Un fichier statique
 * n'est pas une page PWA : il doit être servi par le serveur, pas par le SPA.
 */
export const isStaticFile = (path: string): boolean =>
  /\.[a-z0-9]{2,5}(?:[?#].*)?$/i.test(path);

/** Lien destiné à s'ouvrir dans un nouvel onglet/fenêtre (target != _self). */
export const opensNewTab = (target?: string): boolean =>
  !!target && target !== "_self";

/**
 * Un lien est routable en client-side (SPA) uniquement si c'est une page interne
 * PWA : ni fichier statique, ni ouverture dans un nouvel onglet. Sinon il doit
 * passer par une navigation navigateur complète.
 */
export const isClientNavigable = (path: string, target?: string): boolean =>
  isInternal(path) && !isStaticFile(path) && !opensNewTab(target);
